<template>
    <table v-if="file && file.type === 'csv'">
        <thead>
            <tr>
                <th v-for="(header, key) in file.content.meta.fields" v-bind:key="'header-' + key">
                    {{ header }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(row, rowKey) in file.content.data" v-bind:key="'row-' + rowKey">
                <td v-for="(column, columnKey) in file.content.meta.fields"
                    v-bind:key="'row-' + rowKey + '-column-' + columnKey">
                    {{ file.content.data[rowKey][column] }}
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import { mapGetters } from 'vuex'
export default {

    computed: {
        ...mapGetters(["file"])
    },
}
</script>

<style lang="scss" scoped>
table {
    border-collapse: collapse;
    border-radius: 5px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);

    font-family: "Quicksand", sans-serif;
    font-weight: bold;
    font-size: 14px;
}

th {
    background: #009578;
    color: #ffffff;
    text-align: left;
}


thead {
    white-space: nowrap;
}

th,
td {
    padding: 10px 20px;
}

tr:nth-child(even) {
    background: #eeeeee;
}
</style>